var ProductComponent = function () {

    var componentID = 0;
    var pagination = {};
    var currentEntries = 0;
    var categoriesID = [];

    this.init = function () {

        componentID = $("[data-component='product-search']").data("id");

        $.ajax({
            type: "POST",
            url: "/umbraco/surface/Products/FirstLoad",
            data: JSON.stringify({ "ProductID": componentID }),
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8",
            success: function (response) {

                $(".filters-content").append(appendCategory(response.CategoryList));
                $("#itemsAppend-" + componentID).append(appendProduct(response.ProductList));

                $("#productSearch-" + componentID).text(response.ProductList.length + " de " + response.Pagination.TotalEntries + " resultados encontrados");

                if (!response.Pagination.ShowButton) {
                    $(".interna-lubrificants-btn").hide();
                }
                else {
                    $(".interna-lubrificants-btn").show();
                    pagination = response.Pagination;
                }

                currentEntries = response.ProductList.length;

                $("#firstLoad").hide();
                $("[data-component='product-search']").parents(".container").show();
            },
            error: function (e) {

            }
        });

        $("body").on("change", ".interna-lubrificants input[name='opcoes']", function () {

            $("#itemsAppend-" + componentID).empty();
            $("[data-component='product-search'][data-id='" + componentID + "']").hide();
            $(".interna-lubrificants-btn").hide();
            $("#productLoad").show();

            currentEntries = 0;
            categoriesID = [];
            pagination.CurrentPage = 0;

            var CheckedRadios = $("input[name='opcoes']:checked");

            for (var i = 0; i < CheckedRadios.length; i++) {
                categoriesID.push(CheckedRadios[i].id);
            }

            $.ajax({
                type: "POST",
                url: "/umbraco/surface/Products/FilterProducts",
                data: JSON.stringify({ "CategoriesID": categoriesID, "ProductID": componentID, "Pagination": pagination }),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function (response) {

                    $("#itemsAppend-" + componentID).append(appendProduct(response.ProductList));

                    if (!response.Pagination.ShowButton) {
                        $(".interna-lubrificants-btn").hide();
                    }
                    else {
                        $(".interna-lubrificants-btn").show();
                        pagination = response.Pagination;
                    }

                    currentEntries = response.ProductList.length;

                    if (response.ProductList.length > 1)
                        $("#productSearch-" + componentID).text(response.ProductList.length + " de " + response.Pagination.TotalEntries + " resultados encontrados");
                    else if (response.ProductList.length === 0)
                        $("#productSearch-" + componentID).text("nenhum resultado encontrado");
                    else
                        $("#productSearch-" + componentID).text(response.ProductList.length + " resultado encontrado");

                    $("[data-component='product-search'][data-id='" + componentID + "']").show();
                    $("#productLoad").hide();
                },
                error: function (e) {

                }
            });
        });

        $("body").on("click", ".interna-lubrificants-btn", function () {

            $(".interna-lubrificants-btn").attr("disabled", true);

            pagination.CurrentPage++;

            $.ajax({
                type: "POST",
                url: "/umbraco/surface/Products/FilterProducts",
                data: JSON.stringify({ "CategoriesID": categoriesID, "ProductID": componentID, "Pagination": pagination }),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function (response) {

                    $("#itemsAppend-" + componentID).append(appendProduct(response.ProductList));

                    currentEntries += response.ProductList.length;

                    $("#productSearch-" + componentID).text(currentEntries + " de " + response.Pagination.TotalEntries + " resultados encontrados");

                    if (!response.Pagination.ShowButton) {
                        $(".interna-lubrificants-btn").hide();
                    }
                    else {
                        $(".interna-lubrificants-btn").show();
                        pagination = response.Pagination;
                    }

                    $(".interna-lubrificants-btn").attr("disabled", false);
                },
                error: function (e) {

                }
            });
        });
    }

    var appendCategory = function (categoryList) {

        var html = "";

        for (var i = 0; i < categoryList.length; i++) {

            var category = categoryList[i];

            html += '<div class="filter">';
            html += '   <div data-component="filters" class="interna-lubrificants" data-id="' + category.ID + '">';
            html += '       <form>';
            html += '           <h4>' + category.Name + '</h4>';

            for (var j = 0; j < category.CategoryItemList.length; j++) {

                var categoryItem = category.CategoryItemList[j];

                html += '       <div class="radio">';
                html += '           <input id="' + categoryItem.ID + '" type="checkbox" name="opcoes">';
                html += '           <label for="' + categoryItem.ID + '">';
                html += categoryItem.Name;
                html += '           </label>';
                html += '       </div>';
            }

            html += '       </form>';
            html += '   </div>';
            html += '</div>';
        }

        return html;
    };

    var appendProduct = function (productList) {

        var html = "";

        for (var i = 0; i < productList.length; i++) {

            var item = productList[i];

            html += '<div data-component="product-item">';
            html += '   <div class="img-holder">';
            html += '       <img src="' + item.Image + '" alt="' + item.ImageAltText + '">';
            html += '   </div>';
            html += '   <div class="text-block">';

            if (item.ButtonURL) {
                html += '   <a href="' + item.ButtonURL + '"><h3 class="title">' + item.Title + '</h3></a>';
            }
            else {
                html += '   <h3 class="title">' + item.Title + '</h3>';
            }

            html += '       <div class="description">';
            html += item.Description;
            html += '       </div>';

            if (item.Categories) {

                html += '   <ul class="category-list">';

                for (var j = 0; j < item.Categories.length; j++) {
                    html += '   <li><span>' + item.Categories[j] + '</span></li>'
                }

                html += '   </ul>';
            }

            html += '   </div>';
            html += '</div>';
        }

        return html;
    };

    return this.init();
}